import loading from 'assets/loading.svg'
import * as React from 'react'
// eslint-disable-next-line flowtype/require-valid-file-annotation
// @flow
import styled, { type StyledComponent } from 'styled-components'

type Props = {
  skipLogoutMessage?: boolean,
  overlay?: boolean,
  fullHeight?: boolean,
}

const Spinner: StyledComponent<'div', any, Props> = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props: Props) => {
    if (!props.overlay) return ''

    return `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99;
      background-color: #f3f5f7;
      overflow: hidden;
    `
  }}

  ${(props: Props) => {
    if (!props.fullHeight)
      return `
        padding: 3rem;
    `

    return `
      height: calc(100svh - 70px);
    `
  }}
`
type SpinnerProps = React.ElementConfig<typeof Spinner>

function Loading({
  fullHeight = true,
  overlay,
  ...props
}: SpinnerProps): React.Node {
  return (
    <Spinner fullHeight={fullHeight} overlay={overlay} {...props}>
      <img alt="Loading" src={loading} />
    </Spinner>
  )
}

export default Loading
